import { render } from "./FormTemplate.vue?vue&type=template&id=5e4b9f34"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=5e4b9f34&lang=css"
script.render = render

export default script